import { BoxProps, Box } from '@mui/material';
import InfoIcon from '@watershed/icons/components/Info';
import { IconElement } from '@watershed/icons/Icon';
import Tooltip, { type TooltipProps } from './Tooltip';
import mixinSx from '@watershed/style/mixinSx';

export type IntoTooltipProps = Omit<BoxProps, 'title' | 'marginLeft'> &
  Pick<
    TooltipProps,
    'title' | 'placement' | 'disableInteractive' | 'onOpen'
  > & {
    size?: number;
    tabIndex?: number;
    iconColor?: string;
    tooltipMaxWidth?: number;
    tooltipProps?: Partial<Omit<TooltipProps, 'title'>>;
    Icon?: IconElement;
    /** Whether the icon appears before or after children. */
    iconPosition?: 'start' | 'end';
  };

export default function InfoTooltip({
  children,
  title,
  onOpen,
  component = 'div',
  /** @deprecated use tooltipProps */
  placement = 'top',
  size = 14,
  tabIndex = 0,
  iconColor = 'info.main',
  /** @deprecated use tooltipProps */
  disableInteractive = true,
  Icon = InfoIcon,
  tooltipProps,
  /** @deprecated use tooltipProps */
  tooltipMaxWidth,
  iconPosition = 'end',
  ...boxProps
}: IntoTooltipProps) {
  const icon = (
    <Icon
      size={size}
      color={iconColor}
      flexShrink={0}
      // Hide from PNG export
      data-html2canvas-ignore
    />
  );

  return (
    <Tooltip
      title={title}
      placement={placement}
      disableInteractive={disableInteractive}
      onOpen={onOpen}
      {...tooltipProps}
      sx={mixinSx({ maxWidth: tooltipMaxWidth }, tooltipProps?.sx)}
    >
      <Box
        component={component}
        display="inline-flex"
        alignItems="center"
        gap={0.5}
        tabIndex={tabIndex}
        {...boxProps}
        sx={mixinSx({ cursor: 'help' }, boxProps.sx)}
      >
        {iconPosition === 'start' && icon}
        {children}
        {iconPosition === 'end' && icon}
      </Box>
    </Tooltip>
  );
}
